<template>
  <div class="ticket-left-sidebar">
    <TicketHeaderCard :account-id="accountId" />
    <template
      v-if="
        !ticketStore.loading.isFetchingTickets
      "
    >
      <template v-if="ticketStore.tickets.length <= 0">
        <div class="empty-ticket-placeholder">
          <div class="placeholder-container">
            <feather-icon
              class="icon"
              icon="ArchiveIcon"
              size="26"
            />
            <p class="text">
              {{ $t('ticket.no_ticket') }}
            </p>
          </div>

        </div>
      </template>

      <template v-else>
        <TicketCard
          v-for="(ticket, index) in ticketStore.tickets"
          :key="index"
          :v-if="
            ticketStore.loading.isUpdating !== false ||
              ticketStore.loading.isFetchingMoreTicket !== false ||
              ticketStore.loading.isUpdateSocketData !== false
          "
          :ticket="ticket"

          :account-id="accountId"
          @click="$router.push({name: 'ticket',query: {id: ticket.id}})"
        />
        <!--        :active="ticket.id === ticketStore.selectedTicket.id"-->
      </template>

    </template>

    <template v-else>
      <div class="loading-container">
        <b-spinner
          v-if="true"
          large
          label="Spinning"
        />
      </div>
    </template>
  </div>
</template>
<script>
import useTicketStore from '@/store-pinia/useTicketStore'
import TicketCard from '@/views/ticket/ticketLeftSidebar/ticketList/ticketCard.vue'
import { ref } from '@vue/composition-api'
import { BSpinner, BToast } from 'bootstrap-vue'
import TicketHeaderCard from '@/views/ticket/ticketLeftSidebar/ticketList/ticketHeaderCard.vue'
import { connectSocket } from '@/libs/socket'

export default {
  components: {
    TicketCard,
    BSpinner,
    BToast,
    TicketHeaderCard,
  },
  props: {
    merchantId: {
      type: String,
      default: '',
    },
    accountId: {
      type: String,
      default: '',
    },
  },

  watch: {
    $route(to, from) {
      if (to !== from) {
        // console.log(this.ticketStore.findTicketById(to.query.id))
        // console.log(to.query.id)

        if (this.checkTicketId(this.ticketStore.tickets, to.query.id)) {
          this.handleSelectTicket(to.query.id)
        }
        // this.handleSelectTicket(to.query.id)
      }
    },
  },

  async mounted() {
    this.ticketStore.setAsyncFilterOptions("", "");
    await this.ticketStore.getTicketsAsync()
    await this.ticketStore.getCreateTicketOptionAsync()
    await this.connectSocketSever()
    if (this.checkTicketId(this.ticketStore.tickets, this.$router.currentRoute.query.id)) {
      await this.handleSelectTicket(this.$router.currentRoute.query.id)
    }
    // await this.handleSelectTicket(this.$router.currentRoute.query.id)
  },
  methods: {
    checkTicketId(tickets, idToCheck) {
      return idToCheck !== undefined
      // && (tickets.findIndex(ticket => ticket.id === idToCheck) > -1)
    },
  },

  setup(props) {
    const ticketStore = useTicketStore()
    const socket = ref(null)
    const lastSocketListenID = ref('')
    const connectionStatus = ref(true)
    function connectSocketSever() {
      socket.value = connectSocket()

      socket.value.on('connect', () => {
        connectionStatus.value = true
        console.log('connect 🎫', socket.value)
      })

      socket.value.on('error', error => {
        console.log('error', error)
      })

      socket.value.on('connect_error', () => {
        console.log('connect_error', socket.value)
      })

      socket.value.on('connect_timeout', () => {
        console.log('connect_timeout', socket.value)
      })

      socket.value.on('disconnect', () => {
        connectionStatus.value = false
        console.log('disconnect', socket.value)
      })

      socket.value.on('ping', () => {
        console.log('ping', socket.value)
      })

      socket.value.on('reconnect', attempt => {
        console.log('reconnect', attempt)
      })

      socket.value.on('reconnect_attempt', attempt => {
        console.log('reconnect_attempt', attempt)
      })

      socket.value.on('reconnect_error', error => {
        console.log('reconnect_error', error)
      })

      socket.value.on('reconnect_failed', () => {
        console.log('reconnect_failed', socket.value)
      })

      socket.value.emit('join', {
        event: `${props.merchantId}:tickets`,
      })

      socket.value.on('ticket', res => {
        console.log(
          '📬 New Ticket have created or update',
          JSON.parse(res.data),
        )
        // Check Whether ticket is already exist or not new ticket
        const data = JSON.parse(res.data)
        const isTicketExist = ticketStore.tickets.findIndex(
          ticket => ticket.id === data.id,
        )

        if (data.isDelete === 1) {
          // Ticket is new or already deleted
          ticketStore.removeTicketFromList(data.id)
          ticketStore.setSelectedTicket({})
        } else if (isTicketExist === -1) {
          // Ticket is new
          ticketStore.addTicketToList(data)
          ticketStore.addNewTicketToHistory(data)
        } else if (isTicketExist >= 0) {
          // Ticket is already exist
          ticketStore.updateTicketOnList(data.id, data)
          ticketStore.updateSelectedTicket(data)
        }
      })

      // ⚠️ Warning ⚠️ crazy code
      // Because of there possibility of socket broadcast message to client, before respond with API ENDPOINT
      // So, we need to check for message existing Both on a createTicketMessageAsync [TicketStore.js] function and here
      socket.value.on('ticket:messages', res => {
        const data = JSON.parse(res.data)
        console.log('📬 New Message have been sent', data)

        if (ticketStore.ticketMessagesRef.includes(data.ref)) {
          // check if ticket message is already exist in messageRef
          ticketStore.updateMessageSentStatus(data.ref)
        } else {
          // if not exist, add to message list
          ticketStore.addMessageToList(data)
        }
      })
    }

    function updateLastCheck() {
      try {
        // console.log('select ticket id', ticketStore.selectedTicket.operatorAssigned)
        // console.log('my id', props.accountId)
        const isTicketAssignedToCurrentOperator = ticketStore.selectedTicket.operatorAssigned
        if (isTicketAssignedToCurrentOperator === props.accountId) {
          ticketStore.updateTicketAsync({
            operatorLastSeenAt: new Date().toISOString(),
          })
          console.log('Current Operator Update Last Seen')
        }
      } catch (e) {
        console.log(e)
        console.log('Current Operator Update Last Seen Error')
      }
    }

    function socketListenMessage(ticketId) {
      // If socket is not join any room yet, then continuous otherway, leave the room and join the new room
      if (lastSocketListenID.value !== '') {
        socket.value.emit('leave', {
          event: `${props.merchantId}:${lastSocketListenID.value}`,
        })
      }

      // Save the last ticket id for leave the room next time
      lastSocketListenID.value = ticketId

      // Join new room
      socket.value.emit('join', {
        event: `${props.merchantId}:${ticketId}`,
      })
    }

    async function handleSelectTicket(id) {
      let selectedTicket = ticketStore.tickets.find(ticket => ticket.id === id)
      // console.log('selected ticket 1', selectedTicket)

      if (!selectedTicket) selectedTicket = await ticketStore.getTicketByIdAsync(id)

      if (selectedTicket === {}) return

      // console.log('selected ticket 2', selectedTicket)

      ticketStore.setSelectedTicket(selectedTicket)
      ticketStore.resetTicketMessageParamsOption()
      await ticketStore.getTicketListHistoryAsync()
      await ticketStore.getTicketMessageAsync()
      await ticketStore.getTicketCustomerProfile()
      await ticketStore.getChatMeTicketListHistoryAsync()
      updateLastCheck()
      socketListenMessage(id)
      ticketStore.isRichText = false
    }

    return {
      ticketStore,
      connectSocketSever,
      handleSelectTicket,
    }
  },
}
</script>

<style lang="scss" scoped>
.ticket-left-sidebar {
  height: 100%;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  display: inline;

  .loading-container {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .empty-ticket-placeholder{
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
    color: #6E6B7B;
    .placeholder-container{
      text-align: center;
      .text{
        font-size: 1em;
      }
    }
  }
}
</style>
